import InstructorClosingConversionModule from "./InstructorClosingConversion";
import Saga from "../common/saga";
import { createReducer } from "../common/createReducer";

export default {
  Component: InstructorClosingConversionModule,
  moduleName: "instructorClosingConversion",
  saga: Saga("instructorClosingConversion"),
  reducer: createReducer("instructorClosingConversion")
};
